export const addDevToolsClickListener = (ref: HTMLElement | null, enableDevTools: () => void) => {
  // calls enableDevTools when Cmd+Shift+Option+Double Click is executed on container
  const listener = (e: MouseEvent) => {
    if (e.metaKey && e.shiftKey && e.altKey && e.detail === 2) {
      enableDevTools();
    }
  };
  ref?.addEventListener('click', listener, { capture: true });
  return () => ref?.removeEventListener('click', listener);
};
